/**
 * Секунды разговора (изменение v1.14) — для экрана звонка C-43 и полосы C-44.
 *
 * Отдельным модулем: полоса живёт в оболочке приложения, а экран звонка грузится лениво, и
 * общий хук не должен тянуть экран в стартовый чанк.
 */
import { useEffect, useState } from 'react'

/** Секунды разговора с точностью до секунды — перерисовка раз в секунду, пока идёт звонок. */
export function useCallSeconds(connectedAt: number | null): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (connectedAt === null) return
    const timer = setInterval(() => setNow(Date.now()), 1_000)
    return () => clearInterval(timer)
  }, [connectedAt])
  return connectedAt === null ? 0 : Math.max(0, Math.floor((now - connectedAt) / 1_000))
}
